import request from './request';

const streamingLinksService = {
    list: (show) => {
        return request({
            method: "post",
            url: `links/${encodeURI(show)}`
        });
    },
    get: (show) => {
        return request({
            method: "get",
            url: `media/${encodeURI(show)}/streamingurls`
        });
    },
    cancel: (show, id) => {
        return request({
            method: "delete",
            url: `links/${encodeURI(show)}`
        })
    }
};

export default streamingLinksService;